import { Alert } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';
import { epochDate } from '@hotjar/webapp/lib/time';

export interface ResponseUpgradeAlertStatelessProps {
  total: number;
  upgradeDate: number;
  onDismiss: () => void;
}

export const ResponseUpgradeAlertStateless = ({
  total,
  upgradeDate,
  onDismiss,
}: ResponseUpgradeAlertStatelessProps): JSX.Element | null => {
  const { t, i18n } = useTranslation('feedback');
  return (
    <Alert
      title={t('limits.upgraded.title', { total: total.toLocaleString(i18n.language) })}
      kind="success"
      isDismissible
      onDismiss={onDismiss}
    >
      {t('limits.upgraded.message', { upgradeDate: epochDate(upgradeDate, 'MMMM D') })}
    </Alert>
  );
};
